module.exports = __webpack_public_path__ + "static/img/password-head.4b7774e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/password-head.png
// module id = gBfd
// module chunks = 1